import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { ResponseApi } from '../BaseApi';
import { postSessionStorageLoader } from '../../Apis/functions';

const SearchSlice = createSlice({
    name: 'search',
    initialState: {
        getAttributesFilter: [],
        getConditionFilter: [],
        getValuesByOptionAndField: [],
        getValuesByOptionFieldAndUserId: [],
        searchByFilters: [],
        searchByFiltersCustom: [],
        getListSearchModels: [],
        getValuesToFilterLogByField: [],
        searchCrudLogByModel: [],
        simpleSearch: [],
        simpleSearchWithId: [],
    },
    reducers: {
        clearSearchFilters: (state, action) => {
            state.searchByFilters = [];
            state.searchByFiltersCustom = [];
            state.searchCrudLogByModel = [];
        },
        resetSearchCrudLogByModel: (state, action) => {
            state.searchCrudLogByModel = [];
        },
    },
    extraReducers: {
        'search/getAttributesFilter/fulfilled': (state, action) => {
            state.getAttributesFilter = ResponseApi(action.payload);
        },
        'search/getConditionFilter/fulfilled': (state, action) => {
            state.getConditionFilter = ResponseApi(action.payload);
        },
        'search/getValuesByOptionAndField/fulfilled': (state, action) => {
            state.getValuesByOptionAndField = ResponseApi(action.payload);
        },
        'search/getValuesByOptionFieldAndUserId/fulfilled': (state, action) => {
            state.getValuesByOptionFieldAndUserId = ResponseApi(action.payload);
        },
        'invitation/getInvitationValuesByOptionFieldAndUserId/fulfilled': (state, action) => {
            state.getValuesByOptionFieldAndUserId = ResponseApi(action.payload);
        },
        'search/searchByFilters/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.searchByFilters = data?.data;
                postSessionStorageLoader(false);
            } else if (status >= 400 && status < 600) {
                postSessionStorageLoader(false);
                toast.error(t('error_when_searching').toUpperCase());
            }
        },
        'search/searchByFiltersCustom/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.searchByFiltersCustom = data?.data;
                postSessionStorageLoader(false);
            } else if (status >= 400 && status < 600) {
                postSessionStorageLoader(false);
                toast.error(t('error_when_searching').toUpperCase());
            }
        },
        'search/getListSearchModels/fulfilled': (state, action) => {
            state.getListSearchModels = ResponseApi(action.payload);
        },
        'search/getValuesToFilterLogByField/fulfilled': (state, action) => {
            state.getValuesToFilterLogByField = ResponseApi(action.payload);
        },
        'search/searchCrudLogByModel/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.searchCrudLogByModel = data?.data;
                postSessionStorageLoader(false);
            } else if (status >= 400 && status < 600) {
                postSessionStorageLoader(false);
                toast.error(t('error_when_searching').toUpperCase());
            }
        },
        'search/SimpleSearch/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.simpleSearch = data?.data;
                postSessionStorageLoader(false);
            } else if (status >= 400 && status < 600) {
                postSessionStorageLoader(false);
            }
        },
        'search/SimpleSearchWithId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.simpleSearchWithId = data?.data;
                postSessionStorageLoader(false);
            } else if (status >= 400 && status < 600) {
                postSessionStorageLoader(false);
                toast.error(t('error_when_searching').toUpperCase());
            }
        },
        clearSearchFilters: (state) => {
            state.searchByFilters = [];
            state.searchByFiltersCustom = [];
            state.searchCrudLogByModel = [];
            state.simpleSearch = [];
        },
    },
});

export const { clearSearchFilters, resetSearchCrudLogByModel } = SearchSlice.actions;

export default SearchSlice.reducer;
